import React from 'react';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { BlockType } from '../../types/api/ElementType';
import { PortalLogoDefaultView } from './views/PortalLogoDefaultView';
import { PortalLogoEditView } from './views/PortalLogoEditView';

type ProfileImageProps = Views<
  DefaultView<PortalLogoDefaultView> & OptionalEditView<PortalLogoEditView> & DeleteAction
>;
function PortalLogo({ activeView = 'default', views }: ProfileImageProps) {
  const { t } = useSonTranslation('PortalLogo');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'PortalLogo:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <PortalLogoEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(BlockInteractionsViews.DELETE, Icons.ERASER, 'PortalLogo:delete', DISPLAY_TYPE.MODAL)),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      alwaysShowInfo
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <PortalLogoDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const PortalLogoBlock = asFetchableBlock(PortalLogo, BlockType.portallogo);
